import {Tooltip} from "rsuite";

export const getTooltip = (text) => {
  return (
    <Tooltip>{text}</Tooltip>
  );
}
